import React, { useState, useEffect, useRef, useMemo } from "react";
import { useProfile } from "../../../contexts/ProfileContext";

import ChatInput from "./ChatInput";

//Context
import config from "../../../config";
import { IoIosArrowBack } from "react-icons/io";
import ChatSearch from "./InputSearch";
import customer_avatar from "../../../assets/images/customer_avatar.png";
import { getApi } from "../../AppApis";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImagePreviewModal from "../../Templates/ImagePreviewModal";
import { MediaDocumentModal } from "../../../components/Modal/MediaDocumentModal/MediaDocumentModal";
import { IoPricetagsSharp } from "react-icons/io5";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import ShowerOutlinedIcon from "@mui/icons-material/ShowerOutlined";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";
import { formatUSAPrice } from "../../../helpers/utils";
import { BiLinkExternal } from "react-icons/bi";
import MessageItem from "../MessageItem";

const API_BASE_URL = "http://image.onmls.com";

function CustomerServiceChat(props) {
    const ref = useRef();
    const location = useLocation();
    const { profileData } = useProfile();

    const [chatMessages, setchatMessages] = useState([]);
    const [senderMsg, setSenderMsg] = useState("");
    const [allMsg, setAllMsg] = useState([]);
    const [shareFileNameDir, setShareFileNameDir] = useState([]);
    const [sharedDocuments, setSharedDocuments] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [openMedia, setOpenMedia] = useState(false);
    const [property, setProperty] = useState({});
    const [media_image, setMedia_image] = useState(null);
    const navigate = useNavigate();
    const [ws, setWs] = useState(null);
    const [isMqttConnected, setIsMqttConnected] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const propertyId = props.sellerDetails?.property_id || props.sellerDetails?.external_property_id || searchParams.get("property_id");

    useEffect(() => {
        // make the conversation as read
        if (ws && ws.readyState === WebSocket.OPEN && props.selectedChat?.id) {
            ws.send(
                JSON.stringify({
                    type: "mark_seen",
                    conversation_id: props.selectedChat?.id,
                })
            );
        }
    }, [ws, isMqttConnected]);

    useEffect(() => {
        const accessToken = localStorage.getItem("authUser");
        const token = accessToken.replace(/^"|"$/g, "");
        const wsUrl = `wss://admin.onmls.com/api/messaging/ws/user/${profileData?.id}?token=${token}`;

        const socket = new WebSocket(wsUrl);
        if (!ws) {
            socket.onopen = () => {
                console.log("WebSocket connected");
                setIsMqttConnected(true);
                setWs(socket);
            };

            socket.onmessage = (message) => {
                const payload = JSON.parse(message.data);
                const newPayload = {
                    ...payload,
                    timestamp: new Date().toISOString(),
                };

                setAllMsg((pre) => [...pre, newPayload]);
                scrolltoBottom();
            };

            socket.onerror = (error) => {
                console.error("WebSocket errorrr:", error.message);
            };
        }
        return () => {
            socket.close();
            setWs(null);
        };
    }, []);

    // admin message
    const addMessage = (message, type) => {
        var messageObj = null;

        switch (type) {
            case "textMessage":
                messageObj = {
                    message: message,
                    timestamp: new Date().toISOString(),
                };
                break;

            case "fileMessage":
                messageObj = {
                    media_file: message,
                    timestamp: new Date().toISOString(),
                };
                break;
            case "media_msg":
                messageObj = {
                    media_file: message,
                    timestamp: new Date().toISOString(),
                };
                break;
            default:
                break;
        }

        setchatMessages([...chatMessages, messageObj]);
        setSenderMsg((pre) => {
            return { ...pre, [type]: messageObj };
        });

        scrolltoBottom();
    };

    const scrolltoBottom = () => {
        if (ref.current && ref.current.scrollTo) {
            setTimeout(() => {
                try {
                    ref.current.scrollTo({
                        top: ref.current.scrollHeight,
                        behavior: "smooth",
                    });
                } catch (error) {
                    console.warn("ScrollTo failed:", error);
                }
            }, 100);
        }
    };

    // customer chat
    const handleCustomerSupportChat = async () => {
        try {
            let messageToSend = senderMsg?.textMessage?.message;
            if (allMsg?.length === 1 && allMsg[0].message.includes("how can we help you with")) {
                const propertyAddress = localStorage.getItem("propertyAddress");
                const latestProperty = JSON.parse(localStorage.getItem("latestProperty"));
                messageToSend = `${messageToSend}\n User Name: ${profileData?.first_name}, Contact details: **${profileData?.email}, ${profileData?.phone}** , Property Link:${"https://admin.airebrokers.com/public?propertyId=" + latestProperty.ListingId} \n\n---\n **Property Details:** ${propertyAddress}, $${latestProperty?.price}, ${latestProperty?.beds} beds, ${latestProperty?.baths} baths, ${latestProperty?.size || "N/A"} sqft, ${latestProperty?.built_in} year built, ${latestProperty?.ListingId}`;
            } else if (allMsg?.length === 0) {
                messageToSend = `${messageToSend}\n User Name: ${profileData?.first_name}, Contact details: **${profileData?.email}, ${profileData?.phone}**`;
            }

            let message = {
                type: "send_message",
                message: messageToSend,
                message_type: "text",
            };

            // Add file data if file is selected
            if (media_image) {
                message.media_url = media_image.base64String;
                message.file_name = media_image.fileName;
                message.file_type = "image";
                message.message_type = "image";
            }
            if (propertyId) {
                message.property_id = propertyId;
            }
            console.log("message sended::", message);
            if (!ws || ws.readyState !== WebSocket.OPEN) {
                console.error("WebSocket is not connected");
            } else {
                ws.send(JSON.stringify(message));
                setMedia_image(null);
            }

            setSenderMsg("");
            scrolltoBottom();
        } catch (error) {
            console.error("Error:", error);
        }
    };
    document.title = `Chat | ${config.get("COMPANY_NAME")}`;

    useEffect(() => {
        if (chatMessages?.length > 0) {
            handleCustomerSupportChat();
        }
    }, [chatMessages]);

    // all message of customer and admin
    const fetchData = async () => {
        try {
            let initialMessage;
            if (propertyId) {
                const savedMessage = localStorage.getItem("initialMessage");

                const response = await getApi(`/properties/get_public_property/${propertyId}`);
                setProperty(response.response.data);
                if (savedMessage) {
                    initialMessage = { message: savedMessage, timestamp: new Date().toISOString(), is_response: true };
                    setAllMsg([initialMessage]);
                    localStorage.removeItem("initialMessage");
                    return;
                }
            }
            let requestUrl = `/messaging/customer-service-conversation`;
            let conversationResponse;
            let conversationId;
            if (props.selectedChat !== "customerSupport") {
                requestUrl = `/messaging/conversations/${props.selectedChat?.id}/messages`;
            } else {
                conversationResponse = await getApi(requestUrl);
                conversationId = conversationResponse.response?.data?.conversation_id;
                requestUrl = `/messaging/conversations/${conversationId}/messages`;
            }
            const response = await getApi(requestUrl);
            if (response?.error === 401) {
                navigate("/login");
            } else if (!response?.response) {
                throw new Error("Network response was not ok");
            } else {
                let result = response.response;

                result = result.data;
                const updatedMsgs = result.map((item) => {
                    if (item.message.includes("User Name:")) {
                        // Keep only the part before "User Name:"
                        const cleanedMessage = item.message.split("User Name:")[0].trim();
                        return { ...item, message: cleanedMessage };
                    }
                    // Return unchanged message
                    return item;
                });

                setAllMsg(updatedMsgs);
                scrolltoBottom();
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (propertyId) {
            fetchData();
        } else {
            setProperty(null);
        }
    }, [propertyId]);
    useEffect(() => {
        fetchData();
        scrolltoBottom();
        if (props?.messageValue) {
            setTimeout(() => {
                addMessage(props.messageValue, "textMessage");
            }, 100); // Slightly longer delay to ensure fetchData completes
        }
    }, [props.messageValue]);

    // Auto-scroll when messages change
    useEffect(() => {
        if (allMsg.length > 0) {
            setTimeout(() => {
                scrolltoBottom();
            }, 100);
        }
    }, [allMsg]);

    useEffect(() => {
        const mediaFileName = allMsg?.length > 0 && allMsg?.filter((ele) => ele.media && !ele.media.startsWith("/documents/"));
        const docs = allMsg?.length > 0 && allMsg?.filter((ele) => ele.message?.includes("/documents/") || ele.media?.startsWith("/documents/"));
        setShareFileNameDir(mediaFileName);
        setSharedDocuments(docs);
    }, [allMsg]);

    const onDownloadFile = (fileUrl, filename) => {
        const fullUrl = API_BASE_URL + fileUrl;

        // Create a hidden link element
        const link = document.createElement("a");
        link.href = fullUrl;
        link.setAttribute("download", filename || "download.pdf");
        link.setAttribute("target", "_blank"); // Optional: open in new tab
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const groupedMessages = useMemo(() => {
        const groups = {};
        const messagesToProcess = allMsg?.length > 0 ? allMsg : [];

        messagesToProcess?.forEach((message) => {
            let date;
            if (message.timestamp) {
                date = new Date(message.timestamp);
            } else {
                date = new Date();
            }

            // Create local date string in YYYY-MM-DD format
            const dateKey = [date.getFullYear(), String(date.getMonth() + 1).padStart(2, "0"), String(date.getDate()).padStart(2, "0")].join("-");

            if (!groups[dateKey]) {
                groups[dateKey] = [];
            }
            groups[dateKey].push(message);
        });

        return Object.entries(groups)
            .map(([date, messages]) => ({
                date,
                messages,
            }))
            .sort((a, b) => new Date(a.date) - new Date(b.date));
    }, [allMsg]);

    const getDateLabel = (dateStr) => {
        const date = new Date(dateStr);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        if (date.toDateString() === today.toDateString()) {
            return "Today";
        } else if (date.toDateString() === yesterday.toDateString()) {
            return "Yesterday";
        } else {
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        }
    };

    const scrollToMessage = (messageId) => {
        try {
            const messageElement = document.getElementById(`message-${messageId}`);
            if (messageElement && messageElement.scrollIntoView) {
                messageElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
                // Optional: Add highlight effect to the message
                messageElement.style.backgroundColor = "rgba(255, 255, 0, 0.2)";
                setTimeout(() => {
                    if (messageElement) {
                        messageElement.style.backgroundColor = "transparent";
                        messageElement.style.transition = "background-color 0.5s ease";
                    }
                }, 1500);
            }
        } catch (error) {
            console.warn("ScrollToMessage failed:", error);
        }
    };
    const gotoAllChats = () => {
        document.querySelector(".chats-sidebar-container").classList.add("visible-chat");
        document.querySelector(".chats-sidebar-container").classList.remove("hidden-chat");
        document.querySelector(".chats-container").classList.add("hidden-chat");
        document.querySelector(".chats-container").classList.remove("visible-chat");
        document.querySelector(".directory-main-container")?.classList?.add("hidden-chat");

        document.querySelector(".messaging-wrapper").classList.remove("hidden-chat");
    };

    const filterMessage = (messageText) => {
        return messageText.includes("User Name:") ? messageText.split("User Name:")[0] : messageText;
    };

    return (
        <React.Fragment>
            <div className="main-chat-container  tw-overflow-y-auto">
                <div className={props.userSidebar ? "w-70 overflow-hidden position-relative " : "w-100  overflow-hidden position-relative"}>
                    {/* render user head */}
                    <div className="tw-flex tw-justify-between tw-border-b tw-border-background_secondary_color tw-px-4 tw-items-center tw-gap-2 py-3  tw-bg-white tw-h-[55px] ">
                        <div className="tw-flex tw-gap-2 tw-items-center">
                            <IoIosArrowBack onClick={() => gotoAllChats()} className="tw-text-[24px] md:tw-hidden" />

                            <img className="tw-rounded-full tw-h-[35px] tw-w-[35px]" src={customer_avatar} alt="Customer Service" />
                            <p className="tw-font-semibold tw-text-[20px] tw-text-black "> Customer Service</p>
                        </div>
                        <div className="lg:tw-flex md:tw-flex tw-gap-4 mobile-hide">
                            <ChatSearch messages={allMsg} onMessageSelect={scrollToMessage} />
                            {(shareFileNameDir?.length > 0 || props?.sellerDetails?.external_property_id || sharedDocuments?.length > 0) && (
                                <div
                                    onClick={() => {
                                        setOpenMedia(true);
                                        fetchData();
                                    }}
                                    className="tw-flex tw-items-center tw-cursor-pointer tw-text-[14px] tw-gap-2 tw-justify-center tw-bg-background_color tw-rounded-md tw-p-2 tw-px-4"
                                >
                                    <i className="fi fi-rr-folder tw-mt-1"></i>
                                    Files & Prop Info
                                </div>
                            )}
                        </div>
                    </div>

                    <div
                        style={{
                            height: "calc(100vh - 110px)",
                        }}
                        className=" tw-flex tw-flex-col tw-w-full justify-content-between "
                    >
                        <div className="messaging-wrapper tw-flex tw-flex-col tw-h-full tw-relative tw-rounded-tr-xl ">
                            {property && property?.price && (
                                <div className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-mb-0 tw-font-roboto tw-border-b tw-bg-[#fff] tw-p-2 font-roboto font-normal font-medium text-[10.8px] leading-[19px] text-[#000000] tw-gap-2 tw-text-[12px] tw-py-[2px]  tw-border-r border-gray-500">
                                    <div className="tw-flex tw-flex-col">
                                        <div className="tw-font-semibold tw-text-[18px] tw-text-[#666666]">
                                            {property.StreetNumber
                                                ? `${property.StreetNumber} ${property.StreetName} ${property.StreetSuffix}, ${property.City}, ${property.StateOrProvince} ${property.PostalCode}`
                                                : ""}
                                        </div>
                                        <div className="tw-flex tw-flex-row tw-gap-4 tw-w-full tw-text-[#666666] tw-font-semibold">
                                            <div className="tw-flex tw-gap-1 tw-items-center tw-text-[14px]">
                                                <IoPricetagsSharp className="tw-flex  tw-text-primary" /> ${formatUSAPrice(property?.price) || "N/A"}
                                            </div>
                                            <div className="tw-flex tw-gap-1 tw-items-center tw-text-[14px]">
                                                <BedOutlinedIcon className=" tw-text-primary tw-ml-2" /> {property?.beds} beds
                                            </div>
                                            <div className="tw-flex tw-gap-1 tw-items-center tw-text-[14px]">
                                                <ShowerOutlinedIcon className=" tw-text-primary tw-ml-2" /> {property?.baths} baths
                                            </div>
                                            <div className="tw-flex tw-gap-1 tw-items-center tw-text-[14px]">
                                                <StraightenOutlinedIcon className="tw-ml-2  tw-text-primary" /> {property?.LivingArea} sqft
                                            </div>
                                        </div>
                                    </div>
                                    <Link
                                        to={`/preview/${property.ListingId}?from=chat${props.sellerDetails?.id ? "-" + props.sellerDetails?.id : ""}`}
                                        className="tw-flex tw-items-center tw-justify-center tw-bg-[#EAEEF4] tw-h-[40px] tw-w-[40px] tw-rounded-full"
                                    >
                                        <BiLinkExternal size={18} className="tw-text-black" />
                                    </Link>
                                </div>
                            )}
                            <div
                                ref={ref}
                                className=" tw-bg-[#FFFFFF] tw-h-full  tw-overflow-y-auto  tw-w-full tw-scrollbar-thin tw-scrollbar-corner-transparent tw-scrollbar-thumb-primary tw-scrollbar-track-transparent "
                            >
                                {groupedMessages.map((group, groupIndex) => (
                                    <div key={groupIndex} className="message-group">
                                        {/* Date Separator */}
                                        <div className="tw-flex tw-justify-center tw-my-4">
                                            <div className="  tw-text-medium_text tw-px-4 tw-py-2 tw-rounded-full tw-text-sm ">
                                                {getDateLabel(group.date)}
                                            </div>
                                        </div>

                                        {/* Messages */}
                                        {group.messages.map((item, index) => {
                                            return (
                                                <MessageItem
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    profileData={profileData}
                                                    onDownloadFile={onDownloadFile}
                                                    filterMessage={filterMessage}
                                                    isCustomerSupport={true}
                                                    sellerDetails={props.sellerDetails}
                                                />
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>

                            <ChatInput onaddMessage={addMessage} setMedia_image={setMedia_image} />
                        </div>
                    </div>
                </div>
            </div>
            {openMedia && (
                <MediaDocumentModal
                    onCancel={() => {
                        setOpenMedia(false);
                    }}
                    shareFile={shareFileNameDir}
                    sharedDocuments={sharedDocuments}
                    onConfirm={() => setOpenMedia(false)}
                    property={property}
                />
            )}
            {selectedImage && <ImagePreviewModal isOpen={!!selectedImage} onClose={() => setSelectedImage(null)} imageUrl={selectedImage} />}
        </React.Fragment>
    );
}

export default CustomerServiceChat;
